import React from "react";
import Hero from "../../components/medical/Hero";
import LeadershipTeam from "../../components/LeadershipTeam";
import HighlightedContactSection from "../../components/HighlightedContactSection";

export default function TeamPage() {
  return (
    <>
      <Hero title="Team" subheading="Die Menschen hinter der REPEXO." />
      <div className="min-h-screen bg-white">
        <LeadershipTeam variant="page" />
        <HighlightedContactSection
          heading="Sprechen Sie mit unserem Team"
          description="Sie möchten die richtigen Ansprechpartner für Ihr Anliegen? Wir verbinden Sie gerne."
          buttonText="Jetzt Kontakt aufnehmen"
          sectionId="section-team-contact"
        />
      </div>
    </>
  );
}
